import { ReactComponent as PaymentIcon } from './payment.svg';

export const SvgIcons = {
  PaymentIcon,
};
